import { z } from 'zod'

import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { airportRequired, isEmpty, optional, required } from './schemaHelpers'

const language = cap.language.state || 'IT'
const t = translations[language]

const MSG = t.gfCampoObbligatorio

export const buildPlaneServiceSchema = ({ enableArrivoEntro = true } = {}) =>
  z
    .object({
      typeTrip: required(),
      departureDate: required(),
      airportDeparture: airportRequired(),
      airportArrival: airportRequired(),
      arrivalDate: optional(),
      fromHourDeparture: optional(),
      toHourDeparture: enableArrivoEntro ? optional() : z.any().optional(),
      fromHourReturn: optional(),
      toHourReturn: enableArrivoEntro ? optional() : z.any().optional(),
      companyName: optional(),
      classType: optional(),
      seatPreference: optional(),
      luggageType: optional(),
      luggageNumber: optional(),
      luggageWeight: optional(),
      typeBoarding: optional(),
      companyCode: optional(),
      noteAggiuntive: optional()
    })
    .superRefine((data, ctx) => {
      if (data.typeTrip === 'RT' && isEmpty(data.arrivalDate)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['arrivalDate'], message: MSG })
      }
    })
